import React from 'react';
import { motion } from 'framer-motion';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { CookieBanner } from '../components/CookieBanner';
export function TermsPage() {
  return <div className="min-h-screen" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-459">
      <Navigation data-id="element-460" />

      <div className="pt-32 pb-20 px-4" data-id="element-461">
        <div className="max-w-4xl mx-auto" data-id="element-462">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-463">
            <h1 className="text-4xl sm:text-5xl font-bold mb-6" style={{
            color: 'var(--text-primary)'
          }} data-id="element-464">
              Terms of{' '}
              <span style={{
              color: 'var(--accent)'
            }} data-id="element-465">
                Service
              </span>
            </h1>
            <p className="text-sm mb-8" style={{
            color: 'var(--text-muted)'
          }} data-id="element-466">
              Last updated:{' '}
              {new Date().toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
            </p>

            <div className="space-y-8" data-id="element-467">
              <Section title="1. Agreement to Terms" data-id="element-468">
                <p data-id="element-469">
                  By accessing or using IT Monsters's services, you agree to be
                  bound by these Terms of Service. If you disagree with any part
                  of these terms, you may not use our services.
                </p>
              </Section>

              <Section title="2. Services Description" data-id="element-470">
                <p data-id="element-471">
                  IT Monsters provides professional web design and development
                  services, including:
                </p>
                <ul data-id="element-472">
                  <li data-id="element-473">Free website demo creation</li>
                  <li data-id="element-474">Custom website design and development</li>
                  <li data-id="element-475">Website hosting setup assistance</li>
                  <li data-id="element-476">30 days of post-launch support</li>
                </ul>
              </Section>

              <Section title="3. Pricing and Payment" data-id="element-477">
                <p data-id="element-478">
                  <strong data-id="element-479">Free Demo:</strong> We provide a free website demo
                  with no obligation. You only pay if you approve the design and
                  want to launch.
                </p>
                <p data-id="element-480">
                  <strong data-id="element-481">Professional Packages:</strong> One-time payment for
                  complete website. Payment required after demo approval before
                  final launch.
                </p>
                <p data-id="element-482">
                  <strong data-id="element-483">Hosting (€10/month):</strong> Optional hosting and
                  maintenance service.
                </p>
                <p data-id="element-484">
                  All prices are in Euros (€). Payments are non-refundable once
                  work has commenced.
                </p>
              </Section>

              <Section title="4. Project Timeline" data-id="element-485">
                <p data-id="element-486">
                  Standard projects are completed within 24 hours from demo
                  approval. Timeline may vary based on:
                </p>
                <ul data-id="element-487">
                  <li data-id="element-488">Project complexity</li>
                  <li data-id="element-489">Client feedback response time</li>
                  <li data-id="element-490">Content availability</li>
                </ul>
              </Section>

              <Section title="5. Revisions and Changes" data-id="element-491">
                <p data-id="element-492">
                  Our package includes 3 rounds of revisions. Additional
                  revisions may incur extra charges. Major scope changes after
                  approval may require additional fees.
                </p>
              </Section>

              <Section title="6. Intellectual Property" data-id="element-493">
                <p data-id="element-494">
                  Upon full payment, you own all rights to the final website
                  design and code. Before payment, all work remains property of
                  IT Monsters.
                </p>
              </Section>

              <Section title="7. Client Responsibilities" data-id="element-495">
                <p data-id="element-496">Clients are responsible for:</p>
                <ul data-id="element-497">
                  <li data-id="element-498">Providing accurate content and materials</li>
                  <li data-id="element-499">Timely feedback and approvals</li>
                  <li data-id="element-500">
                    Domain registration and hosting (if not using our services)
                  </li>
                  <li data-id="element-501">Compliance with applicable laws</li>
                </ul>
              </Section>

              <Section title="8. Limitation of Liability" data-id="element-502">
                <p data-id="element-503">
                  IT Monsters is not liable for indirect, incidental, or
                  consequential damages arising from use of our services. Our
                  total liability is limited to the amount paid for services.
                </p>
              </Section>

              <Section title="9. Termination" data-id="element-504">
                <p data-id="element-505">
                  Either party may terminate the agreement with written notice.
                  Payments for completed work are non-refundable.
                </p>
              </Section>

              <Section title="10. Contact" data-id="element-506">
                <p data-id="element-507">For questions about these Terms, contact us at:</p>
                <p data-id="element-508">
                  Email: legal@itmonsters.agency
                  <br data-id="element-509" />
                  Telegram: @itmonsters
                </p>
              </Section>
            </div>
          </motion.div>
        </div>
      </div>

      <Footer data-id="element-510" />
      <CookieBanner data-id="element-511" />
    </div>;
}
function Section({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <div className="rounded-2xl border p-6 sm:p-8" style={{
    borderColor: 'var(--border)',
    backgroundColor: 'var(--bg-secondary)'
  }} data-id="element-512">
      <h2 className="text-xl sm:text-2xl font-bold mb-4" style={{
      color: 'var(--text-primary)'
    }} data-id="element-513">
        {title}
      </h2>
      <div className="space-y-3 text-sm sm:text-base [&>ul]:list-disc [&>ul]:ml-6 [&>ul]:space-y-2" style={{
      color: 'var(--text-secondary)'
    }} data-id="element-514">
        {children}
      </div>
    </div>;
}